export default __webpack_public_path__ + "static/media/ExclamationIcon.de87ef86.svg";